<div class="flex flex-col gap-4 w-full bg-white  border-gray-300">
  <div class="flex flex-col gap-2 border-b-gray-200">
    @if (isManualInput()) {
      <form nz-form [formGroup]="priceFormGroup">
        <nz-form-item class="!mb-0">
          <nz-form-control [nzErrorTip]="amountErrorTpl">
            <nz-input-number
              formControlName="amount"
              nzSize="large"
              class="!w-full"
              [nzMin]="1"
              [nzPlaceHolder]="'Enter amount...'"
            ></nz-input-number>
            <ng-template #amountErrorTpl let-control>
              @if (control.errors?.['required']) {
                Please enter an amount.
              } @else if (control.errors?.['min']) {
                Amount must be greater than 0.
              }
            </ng-template>
          </nz-form-control>
        </nz-form-item>
      </form>
    } @else {
      <h3 class="text-base font-bold">{{ cart().serviceName }}</h3>
      <div class="flex items-center justify-between font-light">
        <p class="text-sm opacity-50">One time fee</p>
        <p class="text-sm">{{ cart().amount | currency: currencyCode : 'symbol' : '1.2-2' }}</p>
      </div>
    }
  </div>

  @if (showSubPlans && showCouponCode()) {
    <div class="flex w-full items-center gap-4 justify-end">
      <p class="text-xs opacity-75">
        Do you want to list properties? check our
        <span class="cursor-pointer underline" [routerLink]="'/subscriptions'">subscription plans</span>
      </p>
    </div>
  }
</div>
